import { GetServerSidePropsContext } from 'next';
import { IPageData, IResponse } from 'src/interface';
import PageService from 'src/services/PageService';
import ContentMoreSection from 'src/modules/content/components/sections/ContentMoreSection';

const TopicTop = ({
    resp,
    isMobile = true,
    isBot = false,
}: {
    resp: IResponse<IPageData<any>>;
    isMobile: boolean;
    isBot: boolean;
}) => {
    const content = resp?.data?.content || ({} as any);
    return (
        <ContentMoreSection
            {...content}
            sourceTopic={content?.topic?.id}
            ContentItemProps={{
                lazyloadImage: !isBot,
            }}
            isMobile={isMobile}
            typeList="rank"
        />
    );
};

export default TopicTop;

export async function getServerSideProps(
    ctx: GetServerSidePropsContext
): Promise<any> {
    return PageService.get(ctx, 'topic-detail', {
        id: ctx?.params?.id,
        page: ctx.params?.page || 1,
    });
}
